<template>
  <div class="container_enterpriseDynamics">
    <div class="banner"></div>
    <div class="container">
      <h3 class="title">成功案例</h3>
      <Row class="enterpriseDynamics-group">
        <Col v-for="item in caseData" class="item" :xs="24" :sm="12" :md="8" :key="item.id">
        <div class="item_main" @click="searchDetail(item.id)">
          <div class="item-img" :style="{background: 'url('+item.img+') no-repeat',backgroundSize:'cover'}"></div>
          <div class="item-content">
            <div class="name">{{item.title}}</div>
            <div class="resume">{{item.resume}}
              <span class="textBtn">【查看详情】</span>
            </div>
            <div class="datetime">{{item.dateTime}}</div>
          </div>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import casePic1 from '../../assets/case_01.jpg'
import casePic2 from '../../assets/case_02.jpg'
import casePic3 from '../../assets/case_03.jpg'
var caseSource = [{
  id: 1,
  img: casePic1,
  title: '看病难，贵，有我无忧',
  resume: '俗话说，久病床前无孝子，如果没有足够的经济能力，这些家庭岌岌可危。',
  dateTime: '2018-9-1'
}, {
  id: 2,
  img: casePic2,
  title: '发生意外，多一份保障',
  resume: '生活总是避免不了意外发生，当不幸来临时,谁来替你守护心爱的人...',
  dateTime: '2018-9-1'
}, {
  id: 3,
  img: casePic3,
  title: '生活，因我更美',
  resume: '保险就好比是桥上的栏杆，有了不一定会扶，没有又不敢过桥...',
  dateTime: '2018-9-1'
}]
export default {
  name: "index",
  data() {
    return {
      caseData: caseSource
    }
  },
  methods: {
    searchDetail: function (id) {
      this.$router.push({ path: '/newDetail', query: { id: id, type: 'case' } })
    }
  }
}
</script>

<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less">
@import "../../style/variable";
@media screen and (max-width: 767px) {
  .container_enterpriseDynamics {
    padding-top: 44px;
    .banner {
      height: 125px;
      background: url("./../../assets/m_enterpriseDynamics.png") no-repeat;
      background-size: cover;
    }
    .container {
      padding: 0;
      h3 {
        font-size: 16px;
        padding: 20px 20px 10px;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .container_enterpriseDynamics {
    .banner {
      height: 300px;
      background: url("./../../assets/enterpriseDynamics.jpg") no-repeat;
      background-size: cover;
    }
    .container {
      padding: 50px 0;
      h3 {
        font-size: 24px;
        padding-bottom: 20px;
      }
    }
  }
}
.container_enterpriseDynamics {
  background-color: #f2f2f2;
  .container {
    h3 {
      border-bottom: 1px solid #eaeaea;
    }
    .enterpriseDynamics-group {
      padding: 20px 0;
      .item {
        padding: 0 15px;
        margin-bottom: 20px;
        &:hover {
          transform: translate(5px, -10px);
          transform: scale(1.1, 1.1);
          -webkit-transform: translate(5px, -10px);
          -webkit-transform: scale(1.1, 1.1);
          cursor: pointer;
          .item_main {
            .item-content {
              .name {
                color: #69c;
              }
            }
          }
        }
        .item_main {
          border-radius: 10px;
          padding-bottom: 20px;
          background-color: #ffffff;
          .item-content {
            text-align: center;
            .name {
              color: #333333;
              font-size: 16px;
            }
            .resume {
              padding: 10px;
              font-size: 14px;
              color: #666666;
              text-align: left;
              .textBtn {
                color: #69c;
                font-size: 12px;
              }
            }
            .datetime {
              color: #999999;
            }
          }
          .item-img {
            width: 100%;
            height: 250px;
            margin-bottom: 10px;
            border-bottom: 1px solid #eaeaea;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/EnterpriseDynamics/index.vue